import { Controller } from "@hotwired/stimulus"

// Reveals only the selected package's add-on options (and clears hidden ones so they aren't
// submitted). Package radios carry data-package-id; each options group carries data-package-id.
export default class extends Controller {
  static targets = ["radio", "options"]

  connect() { this.select() }

  select() {
    const selectedId = this.hasRadioTarget
      ? this.radioTargets.find((r) => r.checked)?.dataset.packageId
      : this.optionsTargets[0]?.dataset.packageId // single hidden package
    this.optionsTargets.forEach((group) => {
      const match = group.dataset.packageId === selectedId
      group.hidden = !match
      if (!match) group.querySelectorAll("input[type=checkbox]").forEach((cb) => (cb.checked = false))
    })
  }
}
